import { Injectable, EventEmitter } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { RequestOptions, Headers, Response } from '@angular/http';
import { environment } from '../../../../environments/environment';

// Services
import { LogService } from '../log/log.service';
import { ServerService } from '../server/server.service';
import { HelperService } from '../helper/helper.service';
import { UserService } from '../user/user.service';
import { StorageService } from '../storage/storage.service';
import { LoaderService } from '../loader/loader.service';
import { DiscussionService } from '../discussion/discussion.service';
import { ApplicationService } from '../application/application.service';
// Interfaces
import {
  IService, ICastVote, IApplication, IVote, IApplicationModel
} from '../../interfaces';

// Enums
import { VoteEnum, DiscussionEnum } from '../../enums';
@Injectable()
export class VoteService implements IService {
  // implements IService
  name = 'VoteService';
  test(name, value) {
    console.log('testing', name, value);
  }


  // implements local variables
  private _votes: BehaviorSubject<IVote[]> = new BehaviorSubject<IVote[]>(undefined);

  private _dataStore: {
    Votes: IVote[],
    Vote: IVote
  };

  constructor(

    private _logSrv: LogService,
    private _userSrv: UserService,
    private _serverSrv: ServerService,
    private _helperSrv: HelperService,
    private _storageSrv: StorageService,
    private _loaderSrv: LoaderService,

    private _applicationSrv: ApplicationService,


    private _discussionSrv: DiscussionService,

  ) {
    this._dataStore = {
      Votes: undefined,
      Vote: undefined
    };
  }

  get DataStore() {
    return this._dataStore;
  }

  get VOTES() {
    return this._votes.asObservable();
  }

  set Votes(votes: IVote[]) {
    if (votes) {
      votes.forEach(v => {
        v.Vote = VoteEnum.Convert.getEnum(v.VoteResult);
      });
    }
    this._dataStore.Votes = votes;
    if (!this._userSrv.Data.contact) {
      throw new ReferenceError(
        `Cannot set user's vote when _memberService.sso is undefined`);
    }
    if (votes) {
      this._dataStore.Vote = votes.find(v => v.ContactId.toUpperCase() === this._userSrv.Data.contact.Id.toUpperCase());
      this._logSrv.Debug(this.name, ['user vote is ', this._dataStore.Vote, votes]);
      if (!this._dataStore.Vote) {
        this._dataStore.Vote = {
          ContactId: this._userSrv.Data.contact.Id,
          DateOfVote: new Date(Date.now()),
          PanelMember: this._userSrv.Data.contact.FullName,
          PanelMemberNumber: 0,
          Vote: VoteEnum.Type.Not_Voted,
          VoteId: ''.EmptyGuid(),
          VoteResult: 'Not Voted',
          acep_applicationnumber: '',
          acep_applicationId: ''.EmptyGuid()
        };
      }
    } else {
      this._dataStore = {
        Votes: undefined,
        Vote: undefined
      };
    }

    this._votes.next(votes);
  }

  get = (applicationId: string) => {
    this._logSrv.Debug(
      this.name,
      ['get votes for ', applicationId]);

    let endPoint = environment.APILocation +
      'vote/' + applicationId;

    return this._serverSrv.GetWithAuth(this._userSrv.Data.contact.AcepId, endPoint)
      .map(m => m.json())
      .do(data => {
        this.Votes = data ? JSON.parse(data) : undefined;
        this._logSrv.Debug(this.name, ['_votes ', JSON.parse(data)]);
      })
      .retry(2);
    // .catch(this.handleError);

  }

  post = (vote: ICastVote) => {
    this._logSrv.Debug(
      this.name,
      ['post vote for ', vote]);


    let endPoint = environment.APILocation + 'vote';
    let currentAppStatus = vote.Application.Status;

    return this._serverSrv.PostWithAuth(this._userSrv.Data.contact.AcepId, endPoint, vote)
      .map(m => m.json())
      .do(data => {
        let obj = data ? JSON.parse(data) : undefined;
        this._logSrv.Debug(this.name, ['_votes ', obj]);
        let returnedApp = <IApplication>obj.Item1.Application;
        // if app status has changed, update the application
        if (returnedApp.Status !== currentAppStatus) {

          //CHECK THIS PART AGAINST CUAP - MB 
          'Updating application'.logWithObject(this.name, returnedApp);
          this._applicationSrv.ApplicationModel.Application = returnedApp;
        }
        let returnedVotes = <IVote[]>obj.Item2;
        'Updating votes'.logWithObject(this.name, returnedVotes);
        this.Votes = returnedVotes;
        this._discussionSrv.get(
          vote.Application.Id,
          DiscussionEnum.Location.Internal,
          false).subscribe();
      })
      .retry(2);
    // .catch(this.handleError);
  }


  recastVotes() {

    this._loaderSrv.SetLoading(this.name, true);

    let endPoint = environment.APILocation + 'vote/recast';
    let payload = {
      applicationId: this._applicationSrv.DATA.application.Application.Id,
      contactId: this._userSrv.Data.contact.Id
    }

    return this._serverSrv.PostWithAuth(this._userSrv.Data.contact.AcepId, endPoint, payload)
      .map(m => m.json())
      .do(data => {

        this._storageSrv.RemoveKey(this._storageSrv.KEY_APPLICATION);
        this._applicationSrv
          .getApplication(
            this._userSrv.Data.contact.Id,
            String(payload.applicationId)
          ).subscribe(
            data => {
              //   let obj = <IApplicationModel>data; //data ? JSON.parse(data) : undefined;
              //   let returnedApp = <IApplication>obj.Application;
              //   this._applicationSrv.APPLICATIONMODEL.next(obj);
              this._loaderSrv.SetLoading(this.name, false);
            }

          );
      })
      .retry(2);
  }

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/vote/vote.service.ts